(function (angular) {
	angular.module('bizPartEngage').directive('bizCultureSelector', bizCultureSelectorDirective);

	bizCultureSelectorDirective.$inject = ['bizCore'];

	function bizCultureSelectorDirective(bizCoreProvider) {
		var directive = {
			restrict: 'E',
			scope: {
				useGbflagForUs: '@?',
			},
			templateUrl: function (element, attr) {
				if (attr.templateurl) {
					return siteRootPath + attr.templateurl;
				} else {
					return bizCoreProvider.getView(
						'core.directives.cultureselector',
						'FrontEnd/Core/Directives/Views/CultureSelector.html'
					);
				}
			},
			bindToController: true,
			controller: bizCultureSelectorController,
			controllerAs: 'vm',
		};

		bizCultureSelectorController.$inject = ['bizCoreService', '$rootScope'];

		function bizCultureSelectorController(bizCoreService, $rootScope) {
			var vm = this;

			vm.GetCultures = GetCultures;
			vm.ChangeLanguage = ChangeLanguage;

			function GetCultures() {
				bizCoreService.GetCultures().then(GetCulturesCallback);

				function GetCulturesCallback(response) {
					var cultures = response.data;

					vm.Cultures = [];
					for (var i = 0; i < cultures.length; i++) {
						cultures[i].Flag =
							vm.useGbflagForUs && cultures[i].CultureCode === 'en-US'
								? 'Images/StatFlags/' + GetImageName(cultures[i].CultureCode)
								: cultures[i].ImageUrl;
						cultures[i].ShortCultureCode = GetShortCountryCode(cultures[i].CultureCode);

						if (cultures[i].IsVisible) {
							vm.Cultures.push(cultures[i]);
						}
					}

					vm.CurrentCulture = vm.Cultures.GetItemByValue('Id', ~~currentCultureId);

					function GetShortCountryCode(cultureCode) {
						var ccParts = cultureCode.split('-');
						if (ccParts.length > 0) {
							return ccParts[0];
						}
						return cultureCode;
					}

					function GetImageName(cultureCode) {
						var ccParts = cultureCode.split('-');
						if (ccParts.length > 1) {
							var countryCode = ccParts[1];
							//console.log("useGbflagForUs", vm.useGbflagForUs);
							if (vm.useGbflagForUs) {
								if (countryCode.toLowerCase() == 'us') {
									countryCode = 'GB';
								}
							}
							return countryCode + '.png';
						}
						console.log('culture selector, could not split country code', cultureCode);
					}
				}
			}

			function ChangeLanguage(cultureCode) {
				var url = window.location.href;
				var qs;
				var parts = url.split('?');
				if (parts.length >= 2) {
					url = parts[0];

					var qsParts = parts[1].split(/[&;]/g);
					for (var i = 0; i < qsParts.length; i++) {
						if (qsParts[i].indexOf('lang=') === -1) {
							if (qs) {
								qs = qs + '&' + qsParts[i];
							} else {
								qs = qsParts[i];
							}
						}
					}
				}

				if (qs) qs = '?' + qs + '&';
				else qs = '?';

				var ccParts = cultureCode.split('-');
				window.location.href = url + qs + 'lang=' + ccParts[0];
			}

			function Init() {
				vm.GetCultures();
			}

			vm.$onInit = function () {
				Init();
			};
		}

		return directive;
	}
})(window.angular);
